export default {
    setRefinement: (state, payload) => {
        state.refinedContents = payload;
    },
    resetRefinement: (state) => {
        state.refinedContents  = null;
    }
};